import React from 'react';
import styled from 'styled-components';

import colors from '../../assets/css/colors';

import Close from '../Icons/Close';

const Header = styled.header`
	padding: ${({ add_padding }) => add_padding ? '20px' : '0'};
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	padding-bottom: 1.5em;
	> svg {
		font-size: 10px;
		color: ${colors.nrlDarkGreen};
		margin-right: 1em;
		cursor: pointer;
		&:last-child{
			font-size: 24px;
			border: 1px solid ${colors.darkGrey};
			border-radius: 50%;
			margin-right: 0;
			padding: .175em;
	}

	}
`;
const LeftHeaderPart = styled.div`
		display: flex;
		justify-content: space-between;
		align-items: center;
		> svg {
			font-size: 10px;
			color: ${colors.darkGrey};
			margin-right: 1em;
			cursor: pointer;
		}

`;
const Title = styled.h4`
	font-weight: 700;
	font-size: 18px;
	white-space: nowrap;
`;

const CloseButton = styled.button`
	background: transparent;
	margin: 0;
	border: 0 none;
	padding: 10px;
	margin-left: -10px;
`;

type Props = {
	add_padding?:boolean,
	title: string,
	onClickClose: Function,
	rightIcon?: React.Element<any> | null
}

export const SidebarWidgetHeader = ({ onClickClose, title, rightIcon, add_padding }: Props) => {
	return (
		<Header
			add_padding={add_padding}
		>
			<LeftHeaderPart>
			    <CloseButton onClick={onClickClose}>
					<Close />
				</CloseButton>
				<Title>
					{title}
				</Title>
			</LeftHeaderPart>
			{rightIcon}
		</Header>
	);
};

SidebarWidgetHeader.defaultProps = {
	rightIcon: null
};

export default SidebarWidgetHeader;


// WEBPACK FOOTER //
// ./src/components/SidebarWidget/SidebarWidgetHeader.js